import React, { useCallback, useMemo } from 'react';
import styles from './oauth-confirmation-modal.module.scss';
import { useOauthConfig } from '../../authentication/hooks/use-oauth-config.hook';
import { Button } from 'src/components/design-system';
import { AUTHENTICATION_TYPE } from 'shared/constants';

const OAuthConfirm = ({ organization, lang, open, close }) => {
  const { getConfigByProvider, generateAuthenticationUrl } = useOauthConfig();
  const provider = organization?.unlock?.provider;
  const config = useMemo(() => getConfigByProvider(provider), [provider, getConfigByProvider]);

  const loginWithOauth = useCallback(() => {
    if (!config || organization?.unlock?.type !== AUTHENTICATION_TYPE.OAUTH) {
      return;
    }
    window.location.href = generateAuthenticationUrl(config);
  }, [organization, config, generateAuthenticationUrl]);

  // The server sends `provider: null` when an OAuth method has no recognisable redirect
  // URI, and `getConfigByProvider` then has nothing to return.
  if (!config) {
    return null;
  }

  return (
    <div className={styles.container}>
      <img src={config.logo} alt="logo" className={styles.logo} />
      <Button onClick={loginWithOauth} className={styles.button} type="primary">
        {lang.SIGN_IN.replaceAll('{organization}', organization?.name)}
      </Button>
      <div className={styles.footer}>
        {lang.REDIRECT_MESSAGE.replaceAll('{organization}', organization?.name)
          .split('.')
          .map(part => (
            <p>{part}.</p>
          ))}
      </div>
    </div>
  );
};

export { OAuthConfirm };
